import { useMediaQuery } from '@mui/material';

const MOBILE_MEDIA_QUERY = '(max-width:480px)';

/**
 * 화면 타입 감지 훅
 *
 * 현재 화면의 크기를 기반으로 모바일/데스크톱 타입을 구분합니다.
 * - 480px 이하: 모바일
 * - 480px 초과: 데스크톱
 *
 * @returns {'mobile' | 'desktop'} 현재 화면 타입
 */
export const useScreenType = () => {
  const isMobile = useMediaQuery(MOBILE_MEDIA_QUERY);
  return isMobile ? 'mobile' : 'desktop';
};
